export default {
  vk: "Вконтакте",
  dz: "Дзен",
  fb: "Facebook",
  ok: "Одноклассники",
  tw: "Twitter",
  ig: "Инстаграм",
  tg: 'Telegram',
  yt: 'Youtube',
  gs: "СМИ"
};

export const social = {
  items: {
    vk: "Вконтакте",
    dz: "Дзен",
    fb: "Facebook",
    ok: "Одноклассники",
    tw: "Twitter",
    ig: "Инстаграм",
    tg: "Telegram",
    yt: 'Youtube'
  },
  excluded: {
    name: "gs",
    title: "СМИ",
  },
  name: "Социальные сети"
};
